enum HIGHLIGHT_ITEMS {
    title = "Title",
    fieldContent = "Fields.Content"
}

export default HIGHLIGHT_ITEMS;